module.exports = __webpack_public_path__ + "static/media/1980 Selsdon Park, UK.61bdbeea.jpg";